module.exports = __webpack_public_path__ + "img/collection.8cb4d8e1.svg";